import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const AlertInTriangleIcon = ({
  width = "24",
  height = "24",
  color = "#BCBCBC",
  secondColor = "white",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 14H10.5V9H12.5M12.5 18H10.5V16H12.5M0.5 21H22.5L11.5 2L0.5 21Z"
          fill={color}
        />
        <defs>
          <path
            d="M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z"
            fill={secondColor}
          />
        </defs>
      </svg>
    </IconWrapper>
  );
};
